import { env } from '../lib/env';

export const OAUTH_CONFIG = {
  get AUTHORIZATION_URL() {
    return env.OAUTH2_URL ? `${env.OAUTH2_URL}/oauth2/authorize` : '';
  },
  get TOKEN_URL() {
    return env.OAUTH2_URL ? `${env.OAUTH2_URL}/oauth2/token` : '';
  },
  get LOGOUT_URL() {
    return env.OAUTH2_URL ? `${env.OAUTH2_URL}/api/v1/users/logout` : '';
  },
  get OIDC_LOGOUT_URL() {
    return env.OAUTH2_URL ? `${env.OAUTH2_URL}/oauth2/logout` : '';
  },
  get CLIENT_ID() {
    return env.OAUTH2_CLIENT_ID;
  },
  get REDIRECT_URI() {
    return env.OAUTH2_REDIRECT_URI || `${window.location.origin}/callback`;
  },
  get SCOPE() {
    return env.OAUTH2_SCOPE || 'openid profile';
  },
  get AUDIENCE() {
    return import.meta.env.VITE_OAUTH2_AUDIENCE || '';
  },
} as const;
